/**
 * @fileoverview Composes state and handlers for the NotificationForm page.
 * @module pages/notificationForm/useNotificationForm
 */
import useNotificationFormContext from "./useNotificationFormContext.js";
import useNotificationFormHandlers from "./useNotificationFormHandlers.js";
import { buildNotificationFormViewModel } from "./buildNotificationFormViewModel.js";

/** View-model hook for the NotificationForm page. */
const useNotificationForm = () => {
  const ctx = useNotificationFormContext();
  const handlers = useNotificationFormHandlers(ctx);
  return buildNotificationFormViewModel(ctx, handlers);
};

export default useNotificationForm;
